import { VueRegistration } from "@abaco/web-common/src/app";

const globals: VueRegistration = {
    SampleWidget: {
        meta: {
            i18nDescrKey: "plot-sample-widget-tile",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/SampleWidget.vue"),
    },

    PlotSoilHealth: {
        meta: {
            i18nDescrKey: "plot-soil-health",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/SamplingPointSoilHealth.vue"),
    },

    FarmSoilHealth: {
        meta: {
            i18nDescrKey: "farm-soil-health",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/ScoreDistribution.vue"),
    },

    PlotMapSoilHealth: {
        meta: {
            i18nDescrKey: "plot-map-soil-health",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/sampling-map/SamplingPointSelectionMap.vue"),
    },

    ComparisonSoilHealth: {
        meta: {
            i18nDescrKey: "comparison-soil-health",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/SamplingPointComparison.vue"),
    },

    // ANALYSIS IN PROGRESS - DEPRECATED WIDGET
    AnalysisSoilHealth: {
        meta: {
            i18nDescrKey: "analysis-soil-health-tile",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/DeprecatedAnalysisSoilHealth.vue"),
    },

    // SOIL SAMPLES - PROGRESS OVERVIEW
    SoilSamplesProgressOverview: {
        meta: {
            i18nDescrKey: "soil-samples-progress-overview",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/SoilSamplesProgressOverview/container.vue"),
    },

    ActionLogSoilHealth: {
        meta: {
            i18nDescrKey: "action-log-soil-health-tile",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/SamplingPointActivities.vue"),
    },

    SoilHealthTimeline: {
        meta: {
            i18nDescrKey: "soil-health-timeline-tile",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/ScoreDistributionTimeline.vue"),
    },

    StructureSoilHealth: {
        meta: {
            i18nDescrKey: "structure-soil-health",
            pinnable: true,
            tag: "SOIL_HEALTH",
            filters: [
                "s-c-leader-select-nav-bar-item",
                { component: "farm-select-nav-bar-item", props: { disableAutoSelectSCLeader: true } },
                "campaign-select-nav-bar-item",
            ],
        },
        component: () => import("./components/tiles/SamplingPointSoilTexture.vue"),
    },
    FarmSoilHealthDataTable: () => import("./components/tiles/DetailsSamplingPointsTable.vue"),
    FarmPlotMap: () => import("./components/tiles/DetailsSamplingPointSelectionMap.vue"),
};

export default globals;
